import styled from '@emotion/styled';

export const ContentWrapper = styled.div`
    display: inline-flex;
    flex-wrap: wrap;
    width: 100%;
`;

export const TextWrapper = styled.div`
    display: flex;
    justify-content: space-between;
    font-size: small;
    color: red;
`;
